import { configureStore } from "@reduxjs/toolkit";
import stateSliceReducer from "./redux/actions";

export default configureStore({
  reducer: { slice: stateSliceReducer },
});
